export const CHALLENGE_USER_REPORT_COLUMNS = [
  { id: "challengeUserId", label: "Id", width: "10%" },
  {
    id: "challengeUser",
    label: "Challenge Username",
    width: "18%",
    isObjObj: true,
    child: "user",
    child2: "username",
  },
  {
    id: "user",
    label: "Reporting Username",
    width: "18%",
    isObj: true,
    child: "username",
  },
  {
    id: "isParentReport",
    label: "Reporter Type",
    width: "12%",
  },
  { id: "createdAt", label: "Reporting Date", width: "18%", isDate: true },
  {
    id: "status",
    label: "Status",
    width: "15%",
    isObjList: true,
    list: ["Approved", "Pending", "Reject"],
    child: "label",
  },
  {
    id: "isDeleted",
    label: "IsDeleted",
    width: "7%",
    isList: true,
    list: [false, true],
    clickable: true,
  },
  { id: "reason", label: "Reason", width: "35%" },
  { id: "actions", width: "15%" },
];

export enum ChallengeReportReason {
  spam = "It’s spam",
  dislike = "I just don’t like it",
  hateSpeech = "Hate speech or symbols",
  violence = "Violence or dangerous activities",
  bullying = "Bullying or harassment",
  other = "Something else",
}

export const RADIO_Status_OPTIONS = () => [
  {
    label: "Approved",
    value: "APPROVED",
  },
  {
    label: "Rejected",
    value: "REJECTED",
  },
  {
    label: "Pending",
    value: "PENDING",
  },
];
